// extracted by mini-css-extract-plugin
export default {"wrapper":"Move_wrapper__EyYrc","move":"Move_move__YVvbu"};